import InfoColoredOutlinedSvg from './icon_info_colored_outlined.svg';
import withIconProps from './withIconProps';

export default withIconProps(InfoColoredOutlinedSvg);
